import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../../../environments/environment';
import { CommonService } from '../../common-service';
import { GetConfigVendasGeralResponse } from '../../responses/vendas/config-vendas-geral.response';
import { ConfigVendasGeralLookupsResponse } from '../../responses/vendas/config-vendas-geral-lookups.response';
import { ConfigVendasGeralRequest } from '../../requests/vendas/config-vendas-geral.request';

@Injectable({
    providedIn: 'root',
})
export class ConfigVendasGeralService extends CommonService {
    private readonly apiUrl: string = environment.urlApiVendas + 'ConfigVendasGeral';

    constructor(private httpClient: HttpClient) {
        super();
    }

    public get(): Observable<GetConfigVendasGeralResponse> {
        return this.httpClient
            .get<GetConfigVendasGeralResponse>(this.apiUrl, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }

    // Sem gate de permissão (ver ConfigVendasGeralController.GetLookup no backend) — use esta versão
    // para leituras cross-módulo, onde o chamador não necessariamente tem permissão em Vendas.
    public getLookup(): Observable<GetConfigVendasGeralResponse> {
        const url = `${this.apiUrl}/lookup`;
        return this.httpClient
            .get<GetConfigVendasGeralResponse>(url, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }

    public getLookups(): Observable<ConfigVendasGeralLookupsResponse> {
        return this.httpClient
            .get<ConfigVendasGeralLookupsResponse>(`${this.apiUrl}/lookups`, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }

    public update(id: number, request: ConfigVendasGeralRequest): Observable<GetConfigVendasGeralResponse> {
        const url = `${this.apiUrl}/idConfigVendasGeral/${id}`;
        return this.httpClient
            .put<GetConfigVendasGeralResponse>(url, request, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }
}
